import styled from 'styled-components'
import { theme } from '../../styles/theme'

export const HorizontalSeparator = styled.div`
    inline-size: 100%;
    border-block-end: ${theme.borders.menu};
`
